import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getClientAddressDetails
} from 'services/redux/brandActivtion/conductCamp/action';
import AddressListing from './addressListing';
import {
  locationArea
} from "services/redux/sales/corporate/locations/action";
import { findAllInRenderedTree } from 'react-dom/test-utils';

const mapStateToProps = (state) => ({
    clientAddressListing: state.ConductCampReducer.clientAddressDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getClientAddressDetails
    },
    dispatch
  );


export default connect(mapStateToProps, mapDispatchToProps)(AddressListing);
